<template>
  <div class="account-subscriptions">
    <label class="mt-3">
      Attached Subscriptions
    </label>
    <div class="mb-3 ">
      <div class="d-flex flex-column form-group w-100">


        <t-input
          v-model="searchFilter"
          placeholder="Search for attached subscriptions"
        />
      </div>
      <div class="ml-auto">
        <div class="d-flex align-items-top">
          <toggle-button
            v-model="showExpired"
            sync
            :color="{ checked: '#0080a8', unchecked: '#c2c7d9' }"
          />
          <div style="white-space: nowrap; margin-left: .5rem; margin-top: -1px; cursor: pointer; user-select: none;" @click="() => showExpired = !showExpired">
            Show inactive
          </div>
        </div>
      </div>
    </div>

    <vue-good-table
      :columns="columns"
      styleClass="vgt-table"
      :rows="filteredSubscriptions"
      @on-row-click="({row}) => $router.push({name: 'subscriptions.view', params: {subscriptionId: row.id}})"
    >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'status'">
            <span
              class="sub-status"
              :class="{'sub-status--active': props.row.status === 'Active'}"
            >
              <icon
                v-if="props.row.status === 'Active'"
                icon="tick-small"
              />
              <icon
                v-else
                icon="remove-tag"
              />
              {{ props.row.status }}
            </span>
          </span>

          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>

    </vue-good-table>


    <div class="border-top d-flex mt-4 pt-4">
      <div class="ml-auto">
        <router-link
          v-if="$login.can('subscriptions.create')"
          href="javascript:;"
          class="btn btn-outline-primary"
          :to="{ name: 'subscriptions.create', query: { account_id: account.id } }"
        >
          Create Subscription
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  components: {
    VueGoodTable,
    ToggleButton,
  },

  props: {
    account: {
      required: true,
      type: Object,
    },
  },

  data () {
    return {
      showExpired: false,
      searchFilter: '',
      columns: [
        {
          label: 'Subscription',
          field: 'name',
        },
        {
          label: 'Total users',
          field: 'total_users'
        },
        {
          label: 'Status',
          field: 'status'
        },
      ],
    }
  },

  computed: {
    filteredSubscriptions () {
      return this.account.subscriptions.filter(({name, status}) =>
        name.toLowerCase().includes(this.searchFilter.toLowerCase()) && (this.showExpired ? true : status === 'Active')
      )
    },
  },
}
</script>


<style lang="scss">
.sub-status {
  color: #fd4431;
  &--active {
    color: #16742e;
  }
}

</style>
